export default __webpack_public_path__ + "static/media/Text-field-(4).9a33ffb1.png";